/**
 * ChatChannelGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { ChatChannelData } from './chat_channel_data'

/**
 * ChatChannelGetRes
 */
export interface ChatChannelGetRes {
  /** 频道列表 */
  items?: ChatChannelData[]
}

/**
 * ChatChannelGetRes Schema
 */
export const ChatChannelGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '频道列表',
      format: '[]*model.ChatChannelData',
      items: { $ref: 'ChatChannelData', description: '' },
      type: 'array',
      label: '频道列表',
    },
  },
  type: 'object',
}
